var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['custom-table-container', { dark: _vm.theme == _vm.THEMES.DARK }]},[_c('table',{class:['custom-table my-3 table', { scrollable: _vm.scrollable, bordered: _vm.bordered, borderedColumns: _vm.borderedColumns, 'no-fixed-width': _vm.noFixedWidth }]},[_c('thead',[_vm._t("head")],2),_c('tbody',[_vm._t("body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }